import * as React from 'react';
import S from './TopLinks.styles';
const TopLinks = ({ items }) => {
    return (React.createElement(S.Container, { "aria-label": "Secondary Links" },
        React.createElement(S.ItemList, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, target: item.target }, item.text)))))));
};
export default TopLinks;
